/**
 * Meta Pixel helper.
 *
 * The Pixel base script in /public/index.html only fires on the production
 * hostname (handyhub.co.nz / www.handyhub.co.nz). Everywhere else,
 * `window.fbq` is undefined and these helpers no-op safely — so calling
 * them from any component is always safe.
 *
 * Usage:
 *   import { pixelTrack, pixelPageView } from '../lib/metaPixel';
 *   pixelTrack('Lead', { content_name: 'Provider Signup' });
 */

const isEnabled = () =>
  typeof window !== 'undefined' && typeof window.fbq === 'function';

/** Fire a Meta Pixel standard or custom event safely. No-op if Pixel not loaded. */
export const pixelTrack = (eventName, params = {}) => {
  if (!isEnabled()) return;
  try {
    // Standard events: PageView, Lead, CompleteRegistration, etc.
    // Anything not in Meta's standard list goes through trackCustom.
    const STANDARD = new Set([
      'PageView', 'Lead', 'CompleteRegistration', 'Purchase', 'InitiateCheckout',
      'AddToCart', 'AddPaymentInfo', 'Contact', 'Subscribe', 'StartTrial',
      'Search', 'ViewContent',
    ]);
    if (STANDARD.has(eventName)) {
      window.fbq('track', eventName, params);
    } else {
      window.fbq('trackCustom', eventName, params);
    }
  } catch (e) {
    /* never let pixel errors break the app */
  }
};

/** Fire a PageView for SPA route changes. */
export const pixelPageView = () => pixelTrack('PageView');
